import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import classes from './DropPlaceholder.styles.less';
export default function DropPlaceholder({ className, children, onFileAdd, accepts = 'image/svg+xml', }) {
    const [theme] = useTheme();
    return (_jsxs("div", { className: cx(classes.placeholder, classes[theme], className), children: [_jsxs("div", { className: classes.label, children: [children, " or"] }), _jsxs("label", { className: classes.inputLabel, htmlFor: "file-browse", children: ["Upload file", ' ', _jsx("input", { className: classes.input, type: "file", id: "file-browse", accept: accepts, onChange: (event) => event.target.files[0] && onFileAdd(event.target.files[0]) })] })] }));
}
